import { z } from 'zod/v3';
import { zDataObjectType } from '../zDataObjectType';
import { zDataObjectGroupType } from '../zDataObjectGroupType';

export const ConfidentialDataObjectBaseSchema = z.object({
  /**
   * ID of either "Data Object Description" or "Data Object Group" depending on
   * which of these is not null: "dataObjectType" or "groupType" (see union variants below).
   */
  id: z.number(),
  name: z.string(),
  code: z.string(),
});

export const ConfidentialDataObjectSchema = z.union([
  ConfidentialDataObjectBaseSchema.extend({
    dataObjectType: z.null(),
    groupType: zDataObjectGroupType,
  }).transform(({ groupType, dataObjectType, ...rest }) => ({
    type: groupType,
    ...rest,
  })),
  ConfidentialDataObjectBaseSchema.extend({
    dataObjectType: zDataObjectType,
    groupType: z.null(),
  }).transform(({ groupType, dataObjectType, ...rest }) => ({
    type: dataObjectType,
    ...rest,
  })),
]);
